// Applied coupon data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

export interface AppliedCoupon {
  promotionCode: string;               // The customer-facing string entered ("LAUNCH20")
  couponId: string;                    // Stripe Coupon id
  name: string;                        // Display name ("20% off first 3 months")
  discountType: 'percent' | 'fixed';
  percentOff: number | null;
  amountOffMinor: number | null;       // In subscription's currency
  duration: 'once' | 'repeating' | 'forever';
  durationInMonths: number | null;     // Set when duration='repeating'
  appliedAt: string;
  // expiresAt semantics by duration:
  //   - 'once':      end of next billing period after appliedAt (one cycle of discount)
  //   - 'repeating': appliedAt + durationInMonths
  //   - 'forever':   null (no expiry)
  expiresAt: string | null;
}
